Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: 'Module' } });

const SDK_VERSION = '7.16.0';

exports.SDK_VERSION = SDK_VERSION;
//# sourceMappingURL=version.js.map
